module.exports = __webpack_public_path__ + "static/media/img8.5008c7b0.jpeg";